// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"thumbnail_thumbnail__2S6Gk"};